import React from 'react';

const LiveSupportV2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.66602 4.5841C1.66602 3.20305 2.78557 2.0835 4.16662 2.0835H12.502C13.883 2.0835 15.0026 3.20305 15.0026 4.5841V9.58531C15.0026 10.9664 13.883 12.0859 12.502 12.0859H9.16782L5.00015 14.5865V12.0859H4.16662C2.78557 12.0859 1.66602 10.9664 1.66602 9.58531V4.5841Z",
      stroke: "white",
      strokeWidth: "1.2503",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.50194 12.9197V12.9197C7.50194 14.3007 8.6215 15.4203 10.0025 15.4203H11.6696L15.0038 17.9209V15.4203H15.8373C17.2183 15.4203 18.3379 14.3007 18.3379 12.9197V9.58556C18.3379 8.20452 17.2183 7.08496 15.8373 7.08496H15.0038",
      stroke: "white",
      strokeWidth: "1.2503",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "rect",
    {
      x: "4.16504",
      y: "6.25122",
      width: "1.66707",
      height: "1.66707",
      rx: "0.416767",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "rect",
    {
      x: "7.50195",
      y: "6.25122",
      width: "1.66707",
      height: "1.66707",
      rx: "0.416767",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "rect",
    {
      x: "10.835",
      y: "6.25122",
      width: "1.66707",
      height: "1.66707",
      rx: "0.416767",
      fill: "white"
    }
  )
);
LiveSupportV2.displayName = "Icons.LiveSupportV2";

export { LiveSupportV2 };
//# sourceMappingURL=LiveSupportV2.js.map
